import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoPage from '../../InfoPage';

export default function CaliforniaNotice() {
  const { t } = useTranslation();
  return (
    <InfoPage
      eyebrow={t('info.legalEyebrow')}
      title={t('legalPages.california.title')}
      subtitle={t('legalPages.california.subtitle')}
    >
      {/* Legal text is deliberately NOT machine-translated: a translation
          nobody has legally reviewed would carry meaning no one signed off
          on. The chrome localizes; the binding text stays English, and says
          so in the reader's language. */}
      <p className="info-english-notice"><em>{t('info.englishNotice')}</em></p>
      <p className="info-updated">Last updated: January 2026</p>

      <h2>Categories of Personal Information We Collect</h2>
      <ul>
        <li>Identifiers - name, email, account ID, IP address.</li>
        <li>Commercial information - ticket, order, and Galaxies redemption history.</li>
        <li>Geolocation data - approximate, IP-derived, used to default your language and theater.</li>
        <li>Internet/network activity - app and website usage data.</li>
        <li>Sensitive personal information - only if you apply to drive for OrderUp (government ID, driver's license).</li>
      </ul>
      <p>See our full <a href="/privacy-policy">Privacy Policy</a> for how each category is used and shared.</p>

      <h2>Your California Rights</h2>
      <p>If you're a California resident, you have the right to:</p>
      <ul>
        <li><strong>Know</strong> what personal information we've collected about you.</li>
        <li><strong>Delete</strong> personal information we've collected, subject to certain exceptions (e.g. active ticket records).</li>
        <li><strong>Correct</strong> inaccurate personal information.</li>
        <li><strong>Opt out</strong> of the sale or sharing of personal information - StarView does not sell personal information.</li>
        <li><strong>Limit use</strong> of sensitive personal information (driver application documents) to what's necessary to process your application.</li>
        <li>Not receive discriminatory treatment for exercising any of the above rights.</li>
      </ul>

      <h2>How to Exercise Your Rights</h2>
      <p>
        Submit a request to <a href="mailto:privacy@starviewcinema.com">privacy@starviewcinema.com</a> with
        "California Privacy Request" in the subject line. We'll verify your identity against your account
        details before fulfilling the request, consistent with CCPA/CPRA requirements.
      </p>

      <h2>Authorized Agents</h2>
      <p>
        You may designate an authorized agent to make a request on your behalf by providing written permission;
        we may still require you to verify your own identity directly.
      </p>
    </InfoPage>
  );
}
